import { UPDATE_ACCOUNT_USER, RESET_ACCOUNT_USER } from './constants';

import { makeActionCreator } from '../../utils/actionsUtils';

// on va update le store account avec de nouvelles infos membre
export const updateInfos = makeActionCreator(UPDATE_ACCOUNT_USER, 'user');

// met à zero les infos du membre
export const resetInfos = makeActionCreator(RESET_ACCOUNT_USER);



// WEBPACK FOOTER //
// ./src/services/account/actions.js